import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { register } from 'swiper/element/bundle';
import {Swiper} from 'swiper';
import { ApiServiceService } from '../../services/api-service.service';
import { Route, Router } from '@angular/router';
import { environment } from '../../../environments/environment.development';
import { SwiperOptions } from 'swiper/types';
import { Meta, Title } from '@angular/platform-browser';
import { CartService } from 'src/app/services/cart.service';
import { ToastrService } from 'ngx-toastr';

register() 


@Component({
  selector: 'app-spacail-offer',
  templateUrl: './spacail-offer.component.html',
  styleUrl: './spacail-offer.component.scss'
})
export class SpacailOfferComponent {
  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef;

  bannerLoaded = false;
sponsoredLoaded = false;
discountLoaded = false;
electronicsLoaded = false;
bestSellingLoaded = false;
fashionLoaded = false;
arrivalLoaded = false;     // section reached viewport
arrivalLoading = false;   // API in progress
topQualityLoaded = false;

  public swiper!:Swiper; 
  discountProduct: any;
  productOne: any;
  featuredProduct: any;
  trendingProducts: any[] = []; // Store trending products
  bestSellarProduct: any[] = []; // Store trending products
  productImageUrl = environment.ImageBaseUrl;
  // apiBaseUrl = environment.apiBaseUrl;
  discountedProducts: any[] = [];
  loading: boolean = false;
  error: string = '';
  bestSellingProducts: any[] = [];
  isLoggedIn: boolean = false;
// Add these properties
loadingStates: { [key: string]: boolean } = {};
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
 isloginPopup: boolean = false;  // <-- Add this
  swiperConfig: SwiperOptions = {
    slidesPerView: 6,
    breakpoints: {
      320: { slidesPerView: 1 },
      480: { slidesPerView: 2 },
      640: { slidesPerView: 3 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 5 },
      1200: { slidesPerView: 6 }
    }
  };
  productData: any;
  fetchDiscountedElec: any;
 

//   sponsoredProducts = [
//   { name: "Men’s Sports Shoes", discount: 70, image: "assets/shoes.jpg" },
//   { name: "Wrist Watches", discount: 90, image: "assets/watch.jpg" },
//   { name: "Men’s Slippers & Flip Flops", discount: 70, image: "assets/slippers.jpg" },
//   { name: "Laptop Bags", discount: 70, image: "assets/bag.jpg" },
// ];


  sponsored: any;
 banner: any = null;
  bannerCate: any;
  discountOnFashionProducts: any;
  banner1: any;
  newArrivals: any;

selectedVariant = null;
  topQualityProducts: any;


showArrivalProduct = false;
constructor(private api:ApiServiceService , private router:Router, private cdr: ChangeDetectorRef ,
  private titleService: Title,
  private metaService: Meta,
   private cartService:CartService,private toastr: ToastrService
 )
{
}

 getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || ''; // Ensure this matches the field in your payload
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

scrollLeft() {
  this.scrollContainer.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
}

scrollRight() {
  this.scrollContainer.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
}
// ngOnInit(){
//  this.getBanners();
// this.sponsoredProduct();
//   this.allActiveProducts();
//   this.fetchDiscountedProducts();
//   this.fetchDiscountedElectroni()
//   this.fetchBestSellingProducts();
//   this.getDiscountedOnFashionProducts();
//  this.newArrivalsProducts();
//  this.getTopQualityProducts();
// }

ngAfterViewInit() {
    this.initializeSwiper(); 
  // this.fetchBestSellingProducts();
  }

loadBanner() {
  if (this.bannerLoaded) return;
  this.bannerLoaded = true;
  this.getBanners();
}

loadArrivals() {
  if (this.arrivalLoaded) return;
  this.arrivalLoaded = true;
   setTimeout(() => {
    this.newArrivalsProducts();
  }, 400);
}

loadSponsored() {
  if (this.sponsoredLoaded) return;
  this.sponsoredLoaded = true;
  this.sponsoredProduct();
}

loadFashion() {
  if (this.fashionLoaded) return;
  this.fashionLoaded = true;
  this.getDiscountedOnFashionProducts();
}

loadDiscounted() {
  if (this.discountLoaded) return;
  this.discountLoaded = true;
  this.fetchDiscountedProducts();
}

loadBestSelling() {
  if (this.bestSellingLoaded) return;
  this.bestSellingLoaded = true;
  this.fetchBestSellingProducts();
}

loadTopQuality() {
  if (this.topQualityLoaded) return;
  this.topQualityLoaded = true;
  this.getTopQualityProducts();
}


fetchBestSellingProducts(): void {
  this.api.getBestSellingProducts().subscribe(
    (response: any) => {
      this.bestSellingProducts = response.data;
    },
    (error) => {
      this.error = error.message || 'Failed to fetch best-selling products';
      // this.loading = true;
    }
  );
}
sponsoredProduct(): void {
  this.api.sponsoredProduct().subscribe(
    (response: any) => {
      this.sponsored = response.sponsoredProducts.slice(0, 4);
      // console.log("sponsored---->" , this.sponsored)
    },
    (error) => {
      this.error = error.message || 'Failed to fetch best-selling products';
      // this.loading = true;
    }
  );
}

fetchDiscountedProducts() {
  this.api.getDiscountedProducts().subscribe({
    next: (products) => {
      this.discountedProducts = products;
      // console.log('discountedProducts-->' ,this.discountedProducts)
      // Initialize all products as loading
      this.discountedProducts.forEach(product => {
        this.loadingStates[product._id] = true;
      });
    },
    error: (err) => {
      console.error('Failed to fetch products:', err);
    }
  });
}

getDiscountedOnFashionProducts() {
  this.api.getDiscountedOnFashionProducts().subscribe({
    next: (products) => {
      this.discountOnFashionProducts = products.slice(0, 4);
      // Initialize all products as loading
      this.discountOnFashionProducts.forEach(product => {
        this.loadingStates[product._id] = true;
      });
    },
    error: (err) => {
      console.error('Failed to fetch products:', err);
    }
  });
}

onImageLoad(productId: string) {
  // Mark this product as loaded
  this.loadingStates[productId] = false;
  this.cdr.detectChanges(); // Trigger change detection
}


fetchDiscountedElectroni() {
  this.loading = true;
  this.api.discountonelectronic().subscribe({
    next: (products : any) => {
      this.fetchDiscountedElec = products;
      this.loadingStates[products._id] = true;
      
    },
    error: (err) => {
      this.error = err.error.message || 'Failed to fetch products';
      // this.loading = true;
    },
  });
}

allActiveProducts(){
  this.api.allActiveProducts().subscribe(( res: any)=>{
    this.productData = res
     // Filter trending products
     this.trendingProducts = this.productData.filter((product: any) => product.isTrending === true);
  
    this.discountProduct = this.trendingProducts;
  })
}


// initializeSwiperIfReady() {
//   if (!this.bestSellingLoaded) return;

//   setTimeout(() => {
//     this.initializeSwiper();
//   });
// }


  initializeSwiper() {
    const swiperEl = this.swiperContainer?.nativeElement as any;
    if (!swiperEl) {
      return;
    }
    Object.assign(swiperEl, {
      slidesPerView: 6,
      spaceBetween: 10,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
  
      },
    });
    swiperEl.initialize();
  }

  getProductById(id: any){
    this.router.navigate(["product-details", id])
  }

discountProductList(){
  this.router.navigate(["product-list"],{ state: this.discountedProducts})
  }

bestSellarProductList(){
  this.router.navigate(["product-list"],{ state: this.bestSellingProducts})
}

sponsoredProductList(){
  this.router.navigate(["product-list"],{ state: this.sponsored})
}

// AllArrivalProductList(){
//   this.router.navigate(["product-list"],{ state: this.newArrivals})
// }
discountOnFashionProductList(){
  this.router.navigate(["product-list"],{ state: this.discountOnFashionProducts})
}

getBanners() {
  this.api.getBanners().subscribe((response: any) => {
    if (Array.isArray(response.data) && response.data.length > 0) {
      this.banner1 = response.data; // only 1 banne
      this.banner = response.data[0]; // only 1 banne
    }
  });
}



 TopCategoriesProduct(banner: any) {
    if(banner.referenceType === "Category" ||  banner.RefrenceName === 'Electronics'){
      this.router.navigate(["product-list", banner.referenceId._id]);
    }else{
      this.router.navigate(['product-details',banner.referenceId._id])
    }
    // this.router.navigate(["product-list", id]);
  }

productDetails(product: any) {
    if (product._id) {
    this.router.navigate(['product-details', product._id], { state: { product } });
     } else if (product.slug) {
      // SEO-friendly route using slug
    const cleanSlug = product.slug.replace(/\s+/g, '-');
    this.router.navigate(['/', cleanSlug]);

     }
  }


  arrivalDetails(id : any){
 if (id) {
    this.router.navigate(['product-details', id]);
     }
  }
  newArrivalsProducts(){
   this.api.newArrivalsProduct().subscribe((data: any) => {
      this.newArrivals = data.data;
      console.log('products newArrivals---->' ,this.newArrivals)
    });
}



addToCartFromList(product: any) {
 const userId = this.getCurrentUserId();

if (!userId) {   // check the value, not the function
  this.toastr.error('Please login first');
  return;
}
 
  const param = {
    product_id: product._id,
    size: 'small',
    quantity: 1,
    user_id: userId,
    seller_id: product.seller,
    variantData: this.selectedVariant,
    attributeSize: product.selectedFullSize || null,
    selectedSizeData: product.selectedFullSize || null,
  };

  this.loadingStates[product._id] = true; // optional

  this.cartService.addToCart(param).subscribe({
    next: (res: any) => {
      this.loadingStates[product._id] = false; // optional
      if (res.message.status !== 302) {
        this.toastr.success(res.message);
        window.dispatchEvent(
          new CustomEvent('cartUpdatedIncreament', { detail: 1 })
        );
      } else {
        this.toastr.error(res.message);
        this.router.navigate(['/Signin']);
      }
    },
    error: (err) => {
      this.loadingStates[product._id] = false; // optional
      this.toastr.error('Failed to add to cart');
    }
  });
}



getTopQualityProducts() {
  this.api.GetTopQualityProducts().subscribe((res: any) => {
    this.topQualityProducts = res.data;
  });
}


}
